import { observer } from 'mobx-react-lite'
import { AddAllocationButton } from '@/features/jobs/details/components/PayoutSplitAllocator/AddAllocationButton'
import { type PayoutSplitAllocatorViewModel } from '@/features/jobs/details/components/PayoutSplitAllocator/PayoutSplitAllocatorViewModel'

export interface AddAllocationButtonContainerProps {
  vm: PayoutSplitAllocatorViewModel
}

export const AddAllocationButtonContainer = observer(
  function AddAllocationButtonContainer({
    vm,
  }: AddAllocationButtonContainerProps) {
    return (
      <AddAllocationButton
        isDisabled={!vm.canAddAllocation}
        onAddAllocation={vm.addAllocation}
      />
    )
  },
)
